var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBing = function SvgBing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    rx: 15.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#E5E5E5",
    rx: 15.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4h24v24H4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M16.204 12.936a.76.76 0 0 0 .055.374l.033.07.132.338.684 1.757.596 1.533c.17.31.442.553.771.682l.102.038.016.003 1.634.566.625.217.043.015.006.001q.185.047.36.125a2.4 2.4 0 0 1 1.108.983c.287.478.4 1.041.32 1.593v.003l-.02.109-.02.105-.005.012a2 2 0 0 1-.096.31q-.078.21-.199.4-.113.186-.26.349a5.4 5.4 0 0 0 1.423-4.058 5.4 5.4 0 0 0-1.722-3.603 5.3 5.3 0 0 0-.885-.667l-.6-.31-3.046-1.573a.764.764 0 0 0-1.055.628"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bing_svg__a)",
    d: "M16.204 12.936a.76.76 0 0 0 .055.374l.033.07.132.338.684 1.757.596 1.533c.17.31.442.553.771.682l.102.038.016.003 1.634.566.625.217.043.015.006.001q.185.047.36.125a2.4 2.4 0 0 1 1.108.983c.287.478.4 1.041.32 1.593v.003l-.02.109-.02.105-.005.012a2 2 0 0 1-.096.31q-.078.21-.199.4-.113.186-.26.349a5.4 5.4 0 0 0 1.423-4.058 5.4 5.4 0 0 0-1.722-3.603 5.3 5.3 0 0 0-.885-.667l-.6-.31-3.046-1.573a.764.764 0 0 0-1.055.628"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M10.781 6a.8.8 0 0 0-.781.801v13.98q.003.146.014.292.01.078.023.157a2.38 2.38 0 0 0 2.338 1.973c.398 0 .79-.1 1.139-.291l.121-.074.491-.291.625-.374.002-12.42a2.4 2.4 0 0 0-1.081-2.016l-2.431-1.6A.8.8 0 0 0 10.81 6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bing_svg__b)",
    d: "M10.781 6a.8.8 0 0 0-.781.801v13.98q.003.146.014.292.01.078.023.157a2.38 2.38 0 0 0 2.338 1.973c.398 0 .79-.1 1.139-.291l.121-.074.491-.291.625-.374.002-12.42a2.4 2.4 0 0 0-1.081-2.016l-2.431-1.6A.8.8 0 0 0 10.81 6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "m20.422 18.772-5.59 3.336-.08.049v.017l-.625.373-.49.292-.12.073-.01.004a2.35 2.35 0 0 1-1.13.288 2.38 2.38 0 0 1-2.34-1.974c.094.822.372 1.586.79 2.252a5.37 5.37 0 0 0 4.012 2.492h1.033c.913-.096 1.676-.464 2.478-.962l1.232-.759c.556-.358 2.063-1.24 2.507-1.734a2.44 2.44 0 0 0 .622-1.631 2.44 2.44 0 0 0-1.81-2.358l-.006-.001-.043-.015z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bing_svg__c)",
    d: "m20.422 18.772-5.59 3.336-.08.049v.017l-.625.373-.49.292-.12.073-.01.004a2.35 2.35 0 0 1-1.13.288 2.38 2.38 0 0 1-2.34-1.974c.094.822.372 1.586.79 2.252a5.37 5.37 0 0 0 4.012 2.492h1.033c.913-.096 1.676-.464 2.478-.962l1.232-.759c.556-.358 2.063-1.24 2.507-1.734a2.44 2.44 0 0 0 .622-1.631 2.44 2.44 0 0 0-1.81-2.358l-.006-.001-.043-.015z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M22.71 20.888a2.5 2.5 0 0 1-.206.986 2.4 2.4 0 0 1-.416.644c-.444.495-1.95 1.377-2.506 1.735l-1.233.76c-.904.56-1.758.957-2.835.984a5.36 5.36 0 0 1-4.687-2.515 5.36 5.36 0 0 1-.79-2.252 2.38 2.38 0 0 0 2.337 1.974c.41 0 .796-.105 1.132-.288l.008-.004.12-.073.491-.292.625-.373v-.017l.08-.05 5.59-3.336.431-.257.043.015.005.001q.186.047.36.125a2.4 2.4 0 0 1 1.11.983c.216.364.341.793.341 1.25",
    opacity: 0.15
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bing_svg__d)",
    d: "M22.71 20.888a2.5 2.5 0 0 1-.206.986 2.4 2.4 0 0 1-.416.644c-.444.495-1.95 1.377-2.506 1.735l-1.233.76c-.904.56-1.758.957-2.835.984a5.36 5.36 0 0 1-4.687-2.515 5.36 5.36 0 0 1-.79-2.252 2.38 2.38 0 0 0 2.337 1.974c.41 0 .796-.105 1.132-.288l.008-.004.12-.073.491-.292.625-.373v-.017l.08-.05 5.59-3.336.431-.257.043.015.005.001q.186.047.36.125a2.4 2.4 0 0 1 1.11.983c.216.364.341.793.341 1.25",
    opacity: 0.15
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M16.204 12.936a.76.76 0 0 0 .055.374l.033.07.132.338.684 1.757.596 1.533c.17.31.442.553.771.682l.102.038.016.003 1.634.566.625.217.043.015.006.001q.185.047.36.125a2.4 2.4 0 0 1 1.108.983c.287.478.4 1.041.32 1.593v.003l-.02.109-.02.105-.005.012a2 2 0 0 1-.096.31q-.078.21-.199.4-.113.186-.26.349a5.4 5.4 0 0 0 1.423-4.058 5.4 5.4 0 0 0-1.722-3.603 5.3 5.3 0 0 0-.885-.667l-.6-.31-3.046-1.573a.764.764 0 0 0-1.055.628"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bing_svg__e)",
    d: "M16.204 12.936a.76.76 0 0 0 .055.374l.033.07.132.338.684 1.757.596 1.533c.17.31.442.553.771.682l.102.038.016.003 1.634.566.625.217.043.015.006.001q.185.047.36.125a2.4 2.4 0 0 1 1.108.983c.287.478.4 1.041.32 1.593v.003l-.02.109-.02.105-.005.012a2 2 0 0 1-.096.31q-.078.21-.199.4-.113.186-.26.349a5.4 5.4 0 0 0 1.423-4.058 5.4 5.4 0 0 0-1.722-3.603 5.3 5.3 0 0 0-.885-.667l-.6-.31-3.046-1.573a.764.764 0 0 0-1.055.628"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M10.781 6a.8.8 0 0 0-.781.801v13.98q.003.146.014.292.01.078.023.157a2.38 2.38 0 0 0 2.338 1.973c.398 0 .79-.1 1.139-.291l.121-.074.491-.291.625-.374.002-12.42a2.4 2.4 0 0 0-1.081-2.016l-2.431-1.6A.8.8 0 0 0 10.81 6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bing_svg__f)",
    d: "M10.781 6a.8.8 0 0 0-.781.801v13.98q.003.146.014.292.01.078.023.157a2.38 2.38 0 0 0 2.338 1.973c.398 0 .79-.1 1.139-.291l.121-.074.491-.291.625-.374.002-12.42a2.4 2.4 0 0 0-1.081-2.016l-2.431-1.6A.8.8 0 0 0 10.81 6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "m20.422 18.772-5.59 3.336-.08.049v.017l-.625.373-.49.292-.12.073-.01.004a2.35 2.35 0 0 1-1.13.288 2.38 2.38 0 0 1-2.34-1.974c.094.822.372 1.586.79 2.252a5.37 5.37 0 0 0 4.012 2.492h1.033c.913-.096 1.676-.464 2.478-.962l1.232-.759c.556-.358 2.063-1.24 2.507-1.734a2.44 2.44 0 0 0 .622-1.631 2.44 2.44 0 0 0-1.81-2.358l-.006-.001-.043-.015z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bing_svg__g)",
    d: "m20.422 18.772-5.59 3.336-.08.049v.017l-.625.373-.49.292-.12.073-.01.004a2.35 2.35 0 0 1-1.13.288 2.38 2.38 0 0 1-2.34-1.974c.094.822.372 1.586.79 2.252a5.37 5.37 0 0 0 4.012 2.492h1.033c.913-.096 1.676-.464 2.478-.962l1.232-.759c.556-.358 2.063-1.24 2.507-1.734a2.44 2.44 0 0 0 .622-1.631 2.44 2.44 0 0 0-1.81-2.358l-.006-.001-.043-.015z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M22.71 20.888a2.5 2.5 0 0 1-.206.986 2.4 2.4 0 0 1-.416.644c-.444.495-1.95 1.377-2.506 1.735l-1.233.76c-.904.56-1.758.957-2.835.984a5.36 5.36 0 0 1-4.687-2.515 5.36 5.36 0 0 1-.79-2.252 2.38 2.38 0 0 0 2.337 1.974c.41 0 .796-.105 1.132-.288l.008-.004.12-.073.491-.292.625-.373v-.017l.08-.05 5.59-3.336.431-.257.043.015.005.001q.186.047.36.125a2.4 2.4 0 0 1 1.11.983c.216.364.341.793.341 1.25",
    opacity: 0.15
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bing_svg__h)",
    d: "M22.71 20.888a2.5 2.5 0 0 1-.206.986 2.4 2.4 0 0 1-.416.644c-.444.495-1.95 1.377-2.506 1.735l-1.233.76c-.904.56-1.758.957-2.835.984a5.36 5.36 0 0 1-4.687-2.515 5.36 5.36 0 0 1-.79-2.252 2.38 2.38 0 0 0 2.337 1.974c.41 0 .796-.105 1.132-.288l.008-.004.12-.073.491-.292.625-.373v-.017l.08-.05 5.59-3.336.431-.257.043.015.005.001q.186.047.36.125a2.4 2.4 0 0 1 1.11.983c.216.364.341.793.341 1.25",
    opacity: 0.15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bing_svg__a",
    x1: 17.108,
    x2: 23.506,
    y1: 13.104,
    y2: 20.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#26C6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#15D0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3BD6DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62DCD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bing_svg__b",
    x1: 12.702,
    x2: 12.495,
    y1: 22.901,
    y2: 7.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B48EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2080F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26B8F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bing_svg__c",
    x1: 16.374,
    x2: 31.741,
    y1: 22.244,
    y2: 22.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#248FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104CF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bing_svg__d",
    x1: 16.373,
    x2: 31.74,
    y1: 22.244,
    y2: 22.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bing_svg__e",
    x1: 17.108,
    x2: 23.506,
    y1: 13.104,
    y2: 20.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#26C6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#15D0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3BD6DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62DCD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bing_svg__f",
    x1: 12.702,
    x2: 12.495,
    y1: 22.901,
    y2: 7.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B48EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2080F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26B8F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bing_svg__g",
    x1: 16.374,
    x2: 31.741,
    y1: 22.244,
    y2: 22.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#248FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104CF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bing_svg__h",
    x1: 16.373,
    x2: 31.74,
    y1: 22.244,
    y2: 22.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
};
export default SvgBing;